import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { OTPVerificationAPIModel, OTPVerificationAPIModelImpl } from './otpverificationapimodel';
import { OTPVerificationCSSStyleImpl } from './otpverificationcss';
import { OTPVerificationViewImpl } from './otpverificationview';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { AddNameTuneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/addnametune/addnametunedto';
import { BuyToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/buytone/buytonedto';
import { OTPCheckDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/otpcheck/otpcheckdto';
import { AlertType } from '../../../toolkit/alert/alerttype';


export interface OTPVerificationComponentProps extends UIComponentProps
{
    channel?:string;
    headerTitle:string;
    id:string;
    toneDto:ToneDto;
    closePopup():void;
    showOptionsPopup(id:string):void;
    showPopup(id:string,msg:string,type:AlertType):void;

}

export interface OTPVerificationComponentHandler extends UIComponentHandler
{
    onConfirmClick():void;
    onClosePopup():void;
    onResendOtpClick():void;
    
}
export interface OTPVerificationComponentState extends UIComponentState
{
    secToc: string;
    isResendButtonRestricted:boolean;
    countDownTime:number;
}

export class OTPVerificationComponent extends UIComponentImpl<OTPVerificationComponentProps, OTPVerificationComponentState, UIDataModel> implements OTPVerificationComponentHandler
{
    private timer: any;
    private countDownTimerInterval:any;
    private duration = Number(this.getContext().getProperty().getResendOtpTimeout());
    private countDownSeconds = this.duration/1000;

    constructor(props: OTPVerificationComponentProps)
    {
        super(props);

        this.state = {isResendButtonRestricted:false, secToc: props.context.getUserContext().getSecToken(),countDownTime:this.countDownSeconds};
        console.log(this.getContext().getUserContext().getPackName());      
    }
    startCountDown() 
    {
        let countDownTimer = document.getElementById("countdown");

     let formatTime = (time:any) =>
     `${String(Math.floor(time / 60)).padStart(2, "0")}:${String(
       time % 60
     ).padStart(2, "0")}`;
      
        this.countDownTimerInterval= setInterval(async() => {
          
     
          if (this.countDownSeconds < 0 ) {
            clearInterval(this.countDownTimerInterval);
            countDownTimer!==null && (countDownTimer.innerHTML = " ");
        
          }
          else{
           
          
         countDownTimer!==null && (countDownTimer.innerHTML = String(formatTime(this.countDownSeconds--)));
          }
         
        }, 900);
      }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new OTPVerificationViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new OTPVerificationCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new OTPVerificationAPIModelImpl(applicationContext, apiModelHandler);
    }
    onConfirmClick():void
    {
        console.log(this.props.id);
        console.log("-----this.props.context.getUserContext().getIsNewUser(): " + this.props.context.getUserContext().getIsNewUser());
        if((this.getView() as OTPVerificationViewImpl).validate())
        {
            (this.getView() as OTPVerificationViewImpl).showLoader(); 
            let otpDto = (this.getView() as OTPVerificationViewImpl).getData() as OTPCheckDtoImpl;
            otpDto.setMsisdn(this.getContext().getUserContext().getMsisdnB());
            otpDto.setSecToc(this.state.secToc);
            (this.getAPIModel() as OTPVerificationAPIModel).otpCheck(otpDto);
        }
        // this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now));
    }
    onClosePopup():void
    {
        this.props.context.getUserContext().setMsisdnB("");
        this.props.context.getUserContext().setSecToken("");
        this.props.context.getUserContext().setUserName("");
        this.props.context.getUserContext().setPackName("");
        this.props.context.getUserContext().setIsnewUser(false);
        this.props.context.setUserContext(this.props.context.getUserContext());
        this.props.closePopup();
    }
    onResendOtpClick(): void 
    {
       
        if(this.state.isResendButtonRestricted === true)
        {
           
        }
        else
        {
           
           
            (this.getView() as OTPVerificationViewImpl).showLoader(); 
        (this.getAPIModel() as OTPVerificationAPIModel).resendOtp(this.getContext().getUserContext().getMsisdnB());
        }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("----------------"+feature);
        (this.getView() as OTPVerificationViewImpl).dismissLoader(); 
        if(feature === APIFeatures.CONFIRM_OTP)
        {
            
            // if(this.props.context.getUserContext().getIsNewUser())
            // {
            //    this.props.showOptionsPopup(this.props.id + "_" + this.props.context.getResources().getString(Strings.subscription));
            // }
            if(this.props.id === this.props.context.getResources().getString(Strings.buy_now))
            {
                (this.getView() as OTPVerificationViewImpl).showLoader();
                let buyTone = new BuyToneDtoImpl();
                buyTone.setToneId(this.props.toneDto.getId());
                buyTone.setToneName(this.props.toneDto.getToneName());
                buyTone.setMsisdn(this.props.context.getUserContext().getMsisdnB());
                buyTone.setLanguage(this.props.context.getUserContext().getLanguage());
                buyTone.setPackName(this.props.context.getUserContext().getPackName());
                buyTone.setUserName(this.props.context.getUserContext().getMsisdnB());
                buyTone.setChannel(this.props.context.getUserContext().getChannelId());
    
                (this.getAPIModel() as OTPVerificationAPIModel).buyTone(buyTone);
            }
            else if(this.props.id === this.props.context.getResources().getString(Strings.buy_nametune))
            {
                console.log(this.getContext().getUserContext().getPackName());
                (this.getView() as OTPVerificationViewImpl).showLoader();
                let addNameTuneDto = new AddNameTuneDtoImpl();
                addNameTuneDto.setChannelId(this.getContext().getUserContext().getChannelId());
                addNameTuneDto.setUserName(this.getContext().getUserContext().getMsisdnB());
                addNameTuneDto.setMsisdn(this.getContext().getUserContext().getMsisdnB());
                addNameTuneDto.setToneId(this.props.toneDto.getId());
                addNameTuneDto.setToneName(this.props.toneDto.getToneName());
                addNameTuneDto.setLanguage(this.getContext().getUserContext().getLanguage());
                addNameTuneDto.setPackName(this.getContext().getUserContext().getPackName());
    
                
                (this.getAPIModel() as OTPVerificationAPIModel).buyNameTone(addNameTuneDto);
            }
        }
        else if(feature === APIFeatures.GENERATE_OTP)
        {
            this.countDownSeconds = this.duration/1000;
            this.startCountDown();
            this.setState({countDownTime:this.countDownSeconds});
          
            this.setState({isResendButtonRestricted:true, secToc: ""});
         
            this.timer = setTimeout(this.setState.bind(this, {isResendButtonRestricted:false}), Number(this.duration));
          
        }
        else if(feature === APIFeatures.ADD_NAMETUNE)
        {
            
            (this.getView() as OTPVerificationViewImpl).dismissLoader();
            (this.props.context.getUserContext().setMsisdnB(""));
            this.props.context.getUserContext().setSecToken("");
            this.props.context.getUserContext().setPackName("");
            this.props.context.getUserContext().setUserName("");
            this.props.context.getUserContext().setIsnewUser(false);
            this.props.context.setUserContext(this.props.context.getUserContext());
            this.props.showPopup(this.getContext().getResources().getString(Strings.otp_verification),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);
        }
        else if(feature === APIFeatures.BUY_TONE)
        {
            console.log("successs");
            (this.getView() as OTPVerificationViewImpl).dismissLoader();
    (this.props.context.getUserContext().setMsisdnB(""));
    this.props.context.getUserContext().setSecToken("");
    this.props.context.getUserContext().setUserName("");
    this.props.context.getUserContext().setPackName("");
    this.props.context.getUserContext().setIsnewUser(false);
    this.props.context.setUserContext(this.props.context.getUserContext());
 
    this.props.showPopup(this.getContext().getResources().getString(Strings.otp_verification),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);   
            }
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
     
        if(feature === APIFeatures.BUY_TONE)
        {
            (this.getView() as OTPVerificationViewImpl).dismissLoader();
            this.props.showPopup(this.props.context.getResources().getString(Strings.otp_verification),description,AlertType.ERROR);     
        }
        else if(feature === APIFeatures.ADD_NAMETUNE)
        {
            (this.getView() as OTPVerificationViewImpl).dismissLoader();
            this.props.showPopup(this.props.context.getResources().getString(Strings.otp_verification),description,AlertType.ERROR);     
        }
        
        else{
        (this.getView() as OTPVerificationViewImpl).dismissLoader(); 
            (this.getView() as OTPVerificationViewImpl).setErrorMsg(description); 
        }
    
    }
    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        
        clearTimeout(this.timer);
       
    }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/otpverification/otpverificationcomponent.tsx